import type { ICoreSimpleTitle } from '~ui/types/components/CoreSimpleTitle';
import type { ICoreAdvancedTitle } from '~ui/types/components/CoreAdvancedTitle';
import { EUnderlineTypes } from '~ui/types/enums/ComponentStyle';

export const fontClasses = (
    blok: ICoreSimpleTitle | ICoreAdvancedTitle,
    breakpoint: string,
    getUnderline?: boolean
) => {
    const mobile = blok.mobileFont?.[0];
    const desktop = blok.font?.[0];

    const fontColorSettings = [
        mobile?.fontColor && mobile?.fontColor != 'custom' ? `text-${mobile?.fontColor}` : '',
        // mobile?.fontColor && mobile?.fontColor === 'custom' && mobile?.customFontColor?.color
        //     ? `text-[${mobile?.customFontColor.color}]`
        //     : '',
        desktop?.fontColor && desktop?.fontColor != 'custom'
            ? `${mobile?.fontColor ? breakpoint + ':' : ''}text-${desktop?.fontColor}`
            : '',
        // desktop?.fontColor && desktop?.fontColor === 'custom' && desktop?.customFontColor?.color
        //     ? `${mobile?.fontColor ? breakpoint + ':' : ''}text-[${desktop?.customFontColor.color}]`
        //     : '',
    ];

    const fontSettings = [
        mobile?.fontSize ? `text-${mobile?.fontSize}` : '',
        mobile?.fontWeight ? `font-${mobile?.fontWeight}` : '',
        mobile?.fontStyle ? `${mobile?.fontStyle}` : '',
        mobile?.alignment ? `text-${mobile?.alignment}` : '',
        mobile?.textDecoration ? `${mobile?.textDecoration}` : '',
        mobile?.textTransform ? `${mobile?.textTransform}` : '',
        // TEMP: Condition used for temporary fallback for Tabbed Searchbox Hero
        desktop?.fontSize
            ? desktop.fontSize === '150'
                ? 'text-5xl'
                : `${mobile?.fontSize ? breakpoint + ':' : ''}text-${desktop?.fontSize}`
            : '',
        desktop?.fontWeight ? `${mobile?.fontWeight ? breakpoint + ':' : ''}font-${desktop?.fontWeight}` : '',
        desktop?.fontStyle ? `${mobile?.fontStyle ? breakpoint + ':' : ''}${desktop?.fontStyle}` : '',
        desktop?.alignment ? `${mobile?.alignment ? breakpoint + ':' : ''}text-${desktop?.alignment}` : '',
        desktop?.textDecoration ? `${mobile?.textDecoration ? breakpoint + ':' : ''}${desktop?.textDecoration}` : '',
        desktop?.textTransform ? `${mobile?.textTransform ? breakpoint + ':' : ''}${desktop?.textTransform}` : '',
    ];

    // Only include classes if the option is set
    // Add breakpoints to classes if mobile option exists
    // Use custom font color if selected
    return [
        ...fontColorSettings,
        ...fontSettings,
        ...(getUnderline ? borderSettings(mobile, desktop, breakpoint) : []),
        ...(getUnderline ? dividerSettings(mobile, desktop, breakpoint) : []),
    ];
};

export const borderSettings = (mobile: IComponentFont, desktop: IComponentFont, breakpoint: string) => [
    mobile?.underline === EUnderlineTypes.BORDER ? `has-underline-border` : '',
    mobile?.underline === EUnderlineTypes.BORDER && mobile?.fontColor != 'custom' ? `border-${mobile.fontColor}` : '',
    mobile?.underline === EUnderlineTypes.BORDER && mobile?.fontColor === 'custom' && mobile?.customFontColor?.color
        ? `border-[${mobile?.customFontColor.color}]`
        : '',
    desktop?.underline === EUnderlineTypes.BORDER
        ? `${mobile?.underline === EUnderlineTypes.BORDER ? breakpoint + ':' : ''}has-underline-border`
        : '',
    desktop?.underline === EUnderlineTypes.BORDER && desktop?.fontColor != 'custom'
        ? `${mobile?.underline === EUnderlineTypes.BORDER ? breakpoint + ':' : ''}border-${desktop.fontColor}`
        : '',
    desktop?.underline === EUnderlineTypes.BORDER && desktop?.fontColor === 'custom' && desktop?.customFontColor?.color
        ? `${mobile?.underline === EUnderlineTypes.BORDER ? breakpoint + ':' : ''}border-[${desktop?.customFontColor.color}]`
        : '',
];

export const dividerSettings = (mobile: IComponentFont, desktop: IComponentFont, breakpoint: string) => [
    mobile?.underline === EUnderlineTypes.DIVIDER ? `has-divider` : '',
    mobile?.underline === EUnderlineTypes.DIVIDER && mobile?.fontColor != 'custom'
        ? `before:border-${mobile.fontColor}`
        : '',
    mobile?.underline === EUnderlineTypes.DIVIDER && mobile?.fontColor === 'custom' && mobile?.customFontColor?.color
        ? `before:border-[${mobile?.customFontColor.color}]`
        : '',
    desktop?.underline === EUnderlineTypes.DIVIDER ? `${mobile?.underline ? breakpoint + ':' : ''}has-divider` : '',
    desktop?.underline === EUnderlineTypes.DIVIDER && desktop?.fontColor != 'custom'
        ? `${mobile?.underline ? breakpoint + ':' : ''}before:bg-${desktop.fontColor}`
        : '',
    desktop?.underline === EUnderlineTypes.DIVIDER && desktop?.fontColor === 'custom' && desktop?.customFontColor?.color
        ? `${mobile?.underline ? breakpoint + ':' : ''}before:bg-[${desktop?.customFontColor.color}]`
        : '',
];

export const fontColorSettings = (desktop: IComponentFont) => {
    if (desktop?.fontColor && desktop?.fontColor === 'custom' && desktop?.customFontColor?.color) {
        return 'color: ' + desktop?.customFontColor.color;
    }
    return '';
};

export const borderColorSettings = (desktop: IComponentFont) => {
    if (desktop?.fontColor && desktop?.fontColor === 'custom' && desktop?.customFontColor?.color) {
        return 'border-color: ' + desktop?.customFontColor.color;
    }
    return '';
};
